angular.module('am4')
.factory('tagService', function($http, $translate, apiUrl) {
    return {
        getAllTags: function() {
            return $http.get(apiUrl + '/tags')
            .then(function(res) {
                return res.data;
            });
        },
        getAvailableTags: function() {

            var availableTags = {
                types: [],
                tags: {}
            };

            return $http.get(apiUrl + '/tags')
            .then(function(res) {
                for (var prop in res.data) {
                    if (res.data.hasOwnProperty(prop)) {
                        let cleanProp = prop.substring(0, (prop.indexOf('_tags')));


                        availableTags.types.push(
                            {
                                value: cleanProp,
                                display: $translate.instant(cleanProp.toUpperCase())
                            }
                        );
                        availableTags.tags[cleanProp] = res.data[prop];
                    }
                }

                return availableTags;
            });
        },
        getUserTags: function(user_id) {
            return $http.get(apiUrl + '/users/' + encodeURIComponent(user_id) + '/tags' )
            .then(function(res) {
                return res.data;
            });
        },
        updateUserTags: function(user_id, tags) {
            return $http.post(apiUrl + '/users/' + encodeURIComponent(user_id) + '/tags', tags)
            .then(function(res) {
                return res.data;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/tag.js